document.addEventListener("DOMContentLoaded", function() {
    // Redirect when clicking the logo
    var logo = document.querySelector("#logo");
    if (logo) {
      logo.addEventListener("click", function() {
        window.location.href = "https://thekuda.com/";
      });
    }

    // Redirect when clicking the cart icon
    var cartIcon = document.querySelector(".mdi-cart");
    var cartText = document.querySelector(".mdi-cart-text");

    if (cartIcon) {
      cartIcon.addEventListener("click", function() {
        window.location.href = "/cart";
      });
    }

    if (cartText) {
      cartText.addEventListener("click", function() {
        window.location.href = "/cart";
      });
    }
  });